import { Injectable } from "@angular/core";
import { VAssetClassSize, SizeCriterionModel } from '../_models'
import * as _ from 'lodash'
import { convertSize } from "../../v2/state/valuation-process/types/asset-class/common";

@Injectable()
export class ValuationProcessSizeCriterionsService {
    createCriterions( refNum: string, sizes: VAssetClassSize[]): SizeCriterionModel[] {
        return sizes.map(size => {
            const values = {}
            values[refNum] = size.size
            return {
                id: 0,
                name: size.standardMeasurementName,
                publicName: size.standardMeasurementName + ` (Required by ToE)`,
                type: 'Size',
                values,
                active: true,
            }
        })
    }

    createComparableCriterion(refNum: string, sizes: VAssetClassSize[], tpUnitMeasurementId: number): SizeCriterionModel[] {
        return sizes.map(size => {
            const values = {}
            values[refNum] = this.sizeConvert(size, tpUnitMeasurementId)
            return {
                id: 0,
                name: size.standardMeasurementName,
                publicName: size.standardMeasurementName + ` (If selected, assumption or special assumption will be required)`,
                type: 'Size',
                values,
                active: false
            }
        })
    }

    createMultipleComparablesCriterion(comparables: {refNum: string, sizes: VAssetClassSize[]}[], tpUnitMeasurementId: number): SizeCriterionModel[] {
        return _.flatten(comparables.map(comparable => this.createComparableCriterion(comparable.refNum, comparable.sizes, tpUnitMeasurementId)))
    }

    private sizeConvert(size: VAssetClassSize, preferredUnitMeasurement: number) {
        if (!preferredUnitMeasurement) return size.size;
        return convertSize(size.size, size.unitOfAreaMeasurementId, preferredUnitMeasurement)
    }
}